import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { DS } from '../../components/ds';
import { BlogContextProvider } from '../../contexts/BlogContext';
import { ArticleList } from '../../components/sections/blog/ArticleList';
import { BlogBreadcrumb } from '../../components/sections/blog/BlogBreadcrumb';
import { BlogTabs } from '../../components/sections/blog/BlogTabs';
import type { BlogArticle } from '../../data/blogArticles';
function BlogPageContent() {
  const navigate = useNavigate();
  const goToArticle = (article: BlogArticle) => {
    navigate(`/blog/${article.id}`);
  };
  return <section style={{
    background: '#fff',
    minHeight: '100vh',
    paddingTop: '68px'
  }} data-id="element-931" data-mp="2lotnqh9zwipu">
      <BlogBreadcrumb items={[{
      label: 'Alinova',
      to: '/'
    }, {
      label: 'Blog'
    }]} data-id="element-932" data-mp="2gra9vih7m7yf" />

      <div style={{
      position: 'relative',
      padding: '56px 24px',
      background: 'linear-gradient(135deg, rgba(0,170,212,0.08) 0%, rgba(45,212,212,0.05) 100%)',
      borderBottom: `1px solid ${DS.color.border}`,
      overflow: 'hidden'
    }} data-id="element-933" data-mp="2bp2t8flfq3pr">
        <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative'
      }} data-id="element-934" data-mp="3f1kri6uvobaf">
          <button type="button" onClick={() => navigate('/')} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          background: 'transparent',
          border: 'none',
          padding: 0,
          marginBottom: '24px',
          color: DS.color.teal,
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          cursor: 'pointer'
        }} data-id="element-935" data-mp="30cwv5yd7jxjf">
            <ArrowLeftIcon size={16} aria-hidden="true" data-id="element-936" data-mp="28k5v1cseloow" />
            Volver al inicio
          </button>

          <h1 style={{
          fontFamily: DS.font.heading,
          fontSize: 'clamp(2.2rem, 5vw, 3rem)',
          fontWeight: 700,
          color: DS.color.ink,
          letterSpacing: '-0.03em',
          lineHeight: 1.1,
          margin: '0 0 14px'
        }} data-id="element-937" data-mp="2cm0xikm2m849">
            Alinova Blog
          </h1>
          <p style={{
          fontFamily: DS.font.body,
          fontSize: '17px',
          color: DS.color.body,
          maxWidth: '520px',
          margin: 0
        }} data-id="element-938" data-mp="9amhyyvz3r49">
            Conocimiento clínico, tendencias y mejores prácticas en
            ortodoncia invisible.
          </p>
        </div>
      </div>

      <BlogTabs data-id="element-939" data-mp="3mk0zzfr3wep9" />

      <div style={{
      padding: '56px 24px 80px'
    }} data-id="element-940" data-mp="3mllig705c76r">
        <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }} data-id="element-941" data-mp="3hl7lpl3zwjo1">
          <ArticleList onSelectArticle={goToArticle} data-id="element-942" data-mp="3hmsg9aqb82lw" />
        </div>
      </div>
    </section>;
}
export function BlogPage() {
  return <BlogContextProvider data-id="element-943" data-mp="1fst64soxbras">
      <BlogPageContent data-id="element-944" data-mp="1ftkov2xf9ujn" />
    </BlogContextProvider>;
}